import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContentSpinner from '../../../shared/Spinner/Spinner';
import Loader from '../../../shared/Events/Loader/Loader';
import OutrightCard from './OutrightCard/OutrightCard';
import useOnScreen from '../../../../hooks/useOnScreen';
import { getOutrights } from '../../../../store/actions/outrights';
import { saveEventFilters } from '../../../../constants/event-filters';
import ConnectionError from '../../ConnectionError/ConnectionError';

const OutrightEvents = props => {
    const dispatch = useDispatch();

    const { ref, isIntersecting: isLoadMoreVisible } = useOnScreen();

    const { seasons, isFetching, isPaginating, hasNextPage, pageOffset } = useSelector(state => state.outrights);
    const { sportRefId, shouldUpdateEvents, isFiltersFetching, filters } = useSelector(state => state.sportEvents);
    const { isSocketConnected, connectionCounter } = useSelector(state => state.socket);

    useEffect(() => {
        if (!isLoadMoreVisible || isFetching || isFiltersFetching || isPaginating || !hasNextPage) return;

        dispatch(getOutrights({ pageOffset }));
    }, [isLoadMoreVisible]);

    useEffect(() => {
        if (Object.keys(filters).length === 0 || !shouldUpdateEvents) return;

        dispatch(getOutrights({ pageOffset: 0 }));
        saveEventFilters({ filters, sportRefId, isOutrights: true });
    }, [filters]);

    return (
        <>
            {isFetching || isFiltersFetching || !connectionCounter ? (
                <ContentSpinner />
            ) : isSocketConnected ? (
                seasons.map(season => {
                    return (
                        <Fragment key={season.id}>
                            {season.markets?.map(market => (
                                <OutrightCard season={season} market={market} />
                            ))}
                        </Fragment>
                    );
                })
            ) : (
                <ConnectionError />
            )}
            {isPaginating ? <Loader /> : null}
            <button className={'v-hidden h-0'} ref={ref}>
                Load More
            </button>
        </>
    );
};

export default OutrightEvents;
